import { Vec2 } from './vec2.js';

/**
 * Represents homogeneous 2D vector.
 */
export class Vec3 {
  constructor(
    public x: number,
    public y: number,
    public w: number = 1,
  ) {}

  add(other: Vec3): Vec3 {
    return new Vec3(this.x + other.x, this.y + other.y);
  }

  sub(other: Vec3): Vec3 {
    return new Vec3(this.x - other.x, this.y - other.y);
  }

  asVec2(): Vec2 {
    return new Vec2(this.x / this.w, this.y / this.w);
  }
}
